import type { ICommunity } from '~/entities/container/community/interfaces/community'
import type { IUser } from '~/entities/user/user/interfaces/user'

import type { TContentContext } from '~/features-shared/config-manager/interfaces/contexts'
import type { IContentModel } from '~/features-shared/content/interfaces/content-model'
import type { IDerivedTypeData } from '~/features-shared/content-derived-type/interfaces/derived-types'
import type { IEntity } from '~/features-shared/libs/interfaces/entity'

/** Interface representing a network activity. */
export interface INetworkActivity extends IEntity {
  /** Action performed. */
  action: Action
  /** Community where the action has been performed. */
  community: ICommunity
  /** List of the contents' URI. */
  content_uri_list: INetworkActivityContent[]
  /** Date of the activity. */
  date: string
  derived_type: Pick<IDerivedTypeData, 'id' | 'label' | 'color' | 'icon'>
  subtype: SubType | '1' | '2' | '3' | 'null' | 'concept'
  /** Id of the content. */
  target_id: string
  /** Title of the content. */
  target_label: string
  model: IContentModel
  /** Type of the content. */
  type: Type
  /** User who performed the action. */
  user: IUser
  title: string
}

/** Interface representing a content in a network activity. */
interface INetworkActivityContent {
  /** Type of the content like "Post", "Media", "Ideation", etc. */
  content_type: TContentContext
  /** URI of the content. */
  subject_uri: string
}

export enum Action {
  Create = 'create',
  Update = 'update',
  Promote = 'promote',
  Vote = 'vote',
  Moderation = 'moderationUpdate',
}

export enum Type {
  Interest = 'interest',
  Education = 'education',
  Work = 'work',
  Community = 'community',
  Profile = 'profile',
  Link = 'link',
  Skill = 'skill',
  SpokenLanguage = 'spokenlanguage',
  Endorse = 'endorse',
  Network = 'network',
  Post = 'post',
  Idea = 'ideation',
  Question = 'question',
  Media = 'media',
  Survey = 'survey',
  Wedo = 'wedo',
  WikiPage = 'wikipage',
  Derived = 'derived',
  Meeting = 'conference',
  Rituals = 'conferencetemplate',

}

export enum SubType {
  Answer = 'answer',
  Comment = 'comment',
}

export enum ENetworkActivity {
  Activity = 'activity',
  Profile = 'profile',
  Network = 'network',
  Invitations = 'invitations',
  Organization = 'organization',
}

export interface NetworkInvitation extends IEntity {
  id: string
  dateC: string
  first_name: string
  last_name: string
  hash_key: string
  notifier_message: string
}

export interface ReceivedInvitation extends NetworkInvitation {
  sender: IUser
  date: string
  /**
   * true if the invitation has been accepted
   */
  isAccepted?: boolean
}

export enum EInvitationsMode {
  Received = 'received',
  Sent = 'sent',
}

export enum EInvitationAcceptStatus {
  Accept = 'accept',
  AcceptAndAdd = 'acceptAdd',
  Decline = 'decline',
}
